import type { FaireProductEntity } from "../../entity_types/product";

export const p_z4uty28dcg: FaireProductEntity = {
  token: "p_z4uty28dcg",
  type: "product",
  name: "Big Dill Birthday Greeting Card",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl: "https://cdn.faire.com/fastly/787f86f163cc4082b1e5da12d91419acc426dbeea0beae46c12381692f5992ea.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/072194dbd326acbbd3ccc9f2627ff5f307ccd7780225dec636f2fd5ea725fad6.png",
    "https://cdn.faire.com/fastly/2e94d549a13ab1c695f49d8ecda3e3d5093891f1b489603de5b05339a65a1e75.png"
  ],
  priceDollars: 3,
  description: "At E. Frances, we believe connection makes the world better. And happier! Our original artwork paired with just-right words warms the heart and helps make meaningful connections easier. Every card begins with a lovingly painted watercolor, and is then printed on luxurious heavyweight paper with brilliant color and, when featured, metallic foil accents.\n\nAnd because we think tiny details can make a big impact, you’ll always find a second illustration on the back of every card!",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:35:20.759Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
